import { render, staticRenderFns } from "./BulkAssignManager.vue?vue&type=template&id=cab07160"
import script from "./BulkAssignManager.vue?vue&type=script&lang=js"
export * from "./BulkAssignManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports